import { Modal } from "react-bootstrap";
import { lgUp } from "Helpers/screenWidth";
import {
  RxCoverageApplicationProp,
  RxCoverageApplicationState,
} from "../../../Rx/RxCoverageApplication/RxCoverageApplication";
import CurrencyHelper from "Helpers/CurrencyHelper";

const getCoverageDetails = (state: RxCoverageApplicationState) => {
  const basicCoverage = state.applicationForm["basicCoverage.coverage"]
    .value as number;
  return {
    basicCoverage,
    damageToRentedProperty: state.applicationForm[
      "additionalCoverages.damageToRentedProperty"
    ].value
      ? 1000000
      : 250000,
    productsCompletedOperationsAggregate: basicCoverage,
    personalAndAdvertisingInjury: basicCoverage,
    generalAggregate: basicCoverage <= 2000000 ? 2000000 : basicCoverage,
  };
};

const ModalCoverageDetails = ({
  show,
  handleClose,
  rxCoverageApplication: [state],
}: {
  show: boolean;
  handleClose: () => void;
  rxCoverageApplication: RxCoverageApplicationProp;
}) => {
  const coverageDetails = getCoverageDetails(state);

  return (
    <Modal
      show={show}
      onHide={() => handleClose()}
      dialogClassName="modal--coverageDetails"
    >
      <Modal.Header
        className={`w-100 border-0 p-0 mb-2 ${
          !lgUp() ? "d-flex flex-column-reverse" : ""
        }`}
        closeButton
      >
        <h4 className="font-weight-bold m-auto w-100 text-center">
          Coverage Details
        </h4>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="container p-0">
          <p className="mb-3">
            <strong>Each Occurrence</strong>
            <br />
            <strong>
              <em>
                {CurrencyHelper.for(coverageDetails.basicCoverage).dollars()}
              </em>
            </strong>
            <br />
            This is the maximum amount the insurer will pay for all claims
            resulting from a single occurrence. The number of injuries, damaged
            property and claims do not affect this amount.
          </p>
          <p className="mb-3">
            <strong>Damage to Rented Premises (Each Occurrence)</strong>
            <br />
            <strong>
              <em>
                {CurrencyHelper.for(
                  coverageDetails.damageToRentedProperty,
                ).dollars()}
              </em>
            </strong>
          </p>
          <p className="mb-3">
            <strong>Medical Expense</strong>
            <br />
            <strong>
              <em>Excluded</em>
            </strong>
          </p>
          <p className="mb-3">
            <strong>
              Products - Completed Operations Aggregate
              <br />
            </strong>
            <em>
              <strong>
                {CurrencyHelper.for(
                  coverageDetails.productsCompletedOperationsAggregate,
                ).dollars()}
              </strong>
            </em>
          </p>
          <p className="mb-3">
            <strong>Personal and Advertising Injury</strong>
            <br />
            <strong>
              <em>
                {CurrencyHelper.for(
                  coverageDetails.personalAndAdvertisingInjury,
                ).dollars()}
              </em>
            </strong>
          </p>
          <p className="mb-3">
            <strong>General Aggregate</strong>
            <br />
            <strong>
              <em>
                {CurrencyHelper.for(coverageDetails.generalAggregate).dollars()}
              </em>
            </strong>
            <br />
            The aggregate limit is the maximum amount an insurer will pay for
            covered losses during a policy period.
          </p>
          <p className="mb-3">
            <strong>Host Liquor </strong>
            <br />
            <strong>
              <em>Included</em>
            </strong>
            <br />
            Required when your venue serves alcoholic beverages or allows
            alcoholic beverages to be consumed on the premises. Includes
            coverage for hosted or cash bars.
          </p>
          <p className="mb-3">
            <strong>Liquor Liability</strong>
            <br />
            <strong>
              <em>Optional</em>
            </strong>
            <br />
            In place of host liquor, coverage for if you are providing alcohol
            at your event as part of your business of manufacturing,
            distributing, selling, serving or furnishing alcoholic beverages.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalCoverageDetails;
